module.exports = __webpack_public_path__ + "media/hk_3F RM1.df66ca4f.mp4";